import styled from 'styled-components';

import { basicHeaderTextStyle, fonts, Link } from '@dreryk/react-components';

export const StyledVisitHeaderPatientNameLink = styled(Link)`
   ${basicHeaderTextStyle};
   font-weight: ${fonts.fontWeightBold};
   flex-shrink: 0;
`;

StyledVisitHeaderPatientNameLink.displayName = 'StyledVisitHeaderPatientNameLink';
